import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ReportingPage } from '@/features/reporting/pages/ReportingPage'

const searchSchema = z.object({
  tab: z.enum(['sales', 'financial', 'tax', 'tourism', 'payroll', 'hospitality']).catch('sales'),
})

export const Route = createFileRoute('/_app/reporting/')({
  validateSearch: searchSchema,
  component: ReportingPage,
})
